import { render, staticRenderFns } from "./FacetItemColor.vue?vue&type=template&id=3f150b15&"
import script from "./FacetItemColor.vue?vue&type=script&lang=js&"
export * from "./FacetItemColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports